module.exports = __webpack_public_path__ + "img/uruguai.78526a97.png";